export const SET_AVAILABLE_CALL_MODES = 'SET_AVAILABLE_CALL_MODES';
export const SET_SELECTED_CALL_MODE = 'SET_SELECTED_CALL_MODE';
export const SET_EXPERIENCE_BOOKING_SUCCESS = 'SET_EXPERIENCE_BOOKING_SUCCESS';
export const SET_EXPERIENCE_BOOKING_IN_PROGRESS = 'SET_EXPERIENCE_BOOKING_IN_PROGRESS';
export const SET_EXPERIENCES_LIST = 'SET_EXPERIENCES_LIST';
export const SET_EXPERIENCE_SELECTED = 'SET_EXPERIENCE_SELECTED';
export const SET_EXPERIENCE_BOOKING_MODAL = 'SET_EXPERIENCE_BOOKING_MODAL';
export const SET_ATLAS_ID = 'SET_ATLAS_ID';
export const SET_CUSTOMER_FIRST_NAME = 'SET_CUSTOMER_FIRST_NAME';
export const SET_CUSTOMER_LAST_NAME = 'SET_CUSTOMER_LAST_NAME';
export const SET_CUSTOMER_CALLBACK_NUMBER = 'SET_CUSTOMER_CALLBACK_NUMBER';
export const SET_CUSTOMER_EMAIL_ADDRESS = 'SET_CUSTOMER_EMAIL_ADDRESS';
export const SET_CUSTOMER_TIME_ZONE = 'SET_CUSTOMER_TIME_ZONE';
export const SET_APPOINTMENT_DATE_TIME = 'SET_APPOINTMENT_DATE_TIME';
export const SET_CAPTCHA_RESPONSE = 'SET_CAPTCHA_RESPONSE';
export const SET_APPOINTMENT_DATA = 'SET_APPOINTMENT_DATA';
export const SET_CUSTOMER_NUMBER = 'SET_CUSTOMER_NUMBER';
export const SET_CURRENT_MODE = 'SET_CURRENT_MODE';
export const SET_CHANNEL = 'SET_CHANNEL';
export const SET_VHT_SEGMENT = 'SET_VHT_SEGMENT';
export const SET_MEGA_USE_CASE = 'SET_MEGA_USE_CASE';
export const SET_MEGA_USE_CASE_DESCRIPTION = 'SET_MEGA_USE_CASE_DESCRIPTION';
export const SET_VHT_SLOTS = 'SET_VHT_SLOTS';
export const SET_CALL_ME_NOW_RESPONSE = 'SET_CALL_ME_NOW_RESPONSE';
export const SET_CREATE_APPT_RESPONSE = 'SET_CREATE_APPT_RESPONSE';
export const GET_NEW_CUSTOMER_SESSION_ID = 'GET_NEW_CUSTOMER_SESSION_ID';
export const SET_ONBOARDING_ANSWERS = 'SET_ONBOARDING_ANSWERS';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/actions/actionTypes.js